import type { CSSProperties } from 'react';
import { optionLabelVh } from './projectionLayout';

// WIP-011 (design §2.4) — the projector's own type scale, in one place. It is
// deliberately NOT the app's normal scale (design §0 rule 4): viewport units
// so it tracks whatever resolution the wall is thrown onto, with the two
// explicit floors (Question, session label) expressed as CSS `max()` so a
// small preview window never renders sub-legible text. Colour always comes
// from a `text-ws-*` className alongside these, never a literal here.
export const QUESTION_STYLE: CSSProperties = { fontSize: 'max(28px, 5vh)', fontWeight: 600, lineHeight: 1.15 };
export const COUNT_ON_BAR_STYLE: CSSProperties = { fontSize: '6vh', fontWeight: 700, fontVariantNumeric: 'tabular-nums' };
export const ANSWERED_COUNTER_STYLE: CSSProperties = {
  fontSize: '14vh', fontWeight: 700, fontVariantNumeric: 'tabular-nums', lineHeight: 1,
};
export const OF_LINE_STYLE: CSSProperties = { fontSize: '3.5vh', fontWeight: 500 };
export const SESSION_LABEL_STYLE: CSSProperties = { fontSize: 'max(18px, 2.5vh)', fontWeight: 500 };

export function optionLabelStyle(totalOptions: number): CSSProperties {
  return { fontSize: `${optionLabelVh(totalOptions)}vh`, fontWeight: 500 };
}
